
const months = {
    1: {
        full: "Januari",
        short: "Jan",
    },
    2: {
        full: "Februari",
        short: "Feb",
    }, 
    3: {
        full: "Mars",
        short: "Mar",
    },
    4: {
        full: "April",
        short: "Apr",
    },
    5: {
        full: "Maj",
        short: "Maj",
    },
    6: {
        full: "Juni",
        short: "Jun",
    },
    7: {
        full: "Juli",
        short: "Jul",
    },
    8: {
        full: "Augusti",
        short: "Aug",
    },
    9: {
        full: "September",
        short: "Sep",
    },
    10: {
        full: "Oktober",
        short: "Okt",
    },
    11: {
        full: "November",
        short: "Nov",
    },
    12: {
        full: "December",
        short: "Dec",
    },
};

const elementInViewport = (el) => {
    var top = el.offsetTop;
    var left = el.offsetLeft;
    var width = el.offsetWidth;
    var height = el.offsetHeight;

    while(el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    return (
        top >= window.pageYOffset &&
        left >= window.pageXOffset &&
        (top + height) <= (window.pageYOffset + window.innerHeight) &&
        (left + width) <= (window.pageXOffset + window.innerWidth)
    );
 };

export default {
    getMonthName: (monthNumber, fullName=true) => {
        return fullName ? months[monthNumber].full : months[monthNumber].short;        
    },
    getFullMonthNameFromShortMonthName: (shortMonthName) => {        
        const monthNumber = Object.keys(months).find(key => months[key].short.toLowerCase() === shortMonthName.toLowerCase());
        if(!monthNumber) {
            return shortMonthName;
        }
        return months[monthNumber].full;
    },
    getArrayOfMonthNamesWithCurrentYear: () => {
        const now = new Date();
        let year = now.getFullYear();
            
        let res = [];
        for (var i = 1; i < 13; ++i) {
            res.push(months[i].short + ' ' + year);
        }
        return res;
    },
    getArrayOfMonthNames: () => {                   
        let res = [];
        for (var i = 1; i < 13; ++i) {
            res.push(months[i].short);
        }
        return res;
    },
    getNext12MonthNamesWithYear: () => {
        const now = new Date();
        let month = now.getMonth();
        let year = now.getFullYear();
            
        let res = [];
        for (var i = 0; i < 12; ++i) {
            res.push(months[month+1].short + ' ' + year);
            if (++month === 12) {
                month = 0;
                ++year;
            }
        }
        return res;
    },   
    shiftValuesToStartWithCurrentMonth: (arr) => {
        const now = new Date();
        const month = now.getMonth();            
        const shiftCount = 12-month;
        let result = [];
        if (arr.length == 1 || shiftCount == 0) {
            return arr;
        }
        for (let index = 0; index < arr.length; index++) {
            result[(index+shiftCount)%arr.length] = arr[index];
        }
        return result;
    },
    getFormatedPrice: (price, decimals) => {
        if(decimals != undefined) {
            price = parseFloat(price).toFixed(decimals)
        }
        return Intl.NumberFormat('sv-SE').format(price) + ' kr';
    },
    getFormatedValue: (price, decimals, unit) => {
        if(decimals != undefined) {
            price = parseFloat(price).toFixed(decimals)
        }
        return Intl.NumberFormat('sv-SE').format(price) + (unit ? ' ' + unit : '');
    },
    scrollIntoViewIfNeeded: (element) => {
        if(!elementInViewport(element)) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }   
}